import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Values from "@/components/Values";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Partnerships from "@/components/Partnerships";
import Studio from "@/components/Studio";
import Capabilities from "@/components/Capabilities";
import Policy from "@/components/Policy";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.5,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="bg-white text-[#270057]">
            <div className="grain-overlay" aria-hidden="true" />
            <Navbar />
            <main>
                <Hero />
                <Values />
                <Marquee />
                <About />
                <Partnerships />
                <Studio />
                <Capabilities />
                <Policy />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}

export default App;
